export default {
    entradasNF: [],
    pedidosNF: [],
    entradaNF: {},
    ultimaAtualizacaoListaEntradaNF: Date
}